import { AppThunkAction } from "..";
import { FamilyServiceAction, GET_FPS_FAMILY_MEMBER, GET_SFR_FAMILY_MEMBER, SFR_FAMILY_MEMBER_LOADER, GET_FAMILY_ADULT_MEMBER_DETAILS,LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS } from "./types";
import * as services from "../service";

export const actionCreators = {
    getFPSFamilySubscribers: (): AppThunkAction<FamilyServiceAction> => (dispatch, getState) => {
        services.getChildSubscribersFPS().then((data) => {
            if (data.isSuccess) {
                if (data["_eZSChildSubscribers"]) {
                    dispatch({ type: GET_FPS_FAMILY_MEMBER, eZSChildSubscribers: data["_eZSChildSubscribers"] });
                }
            }
        });
    },
    getSeniorFamilyMember: (): AppThunkAction<FamilyServiceAction> => (dispatch, getState) => {
        dispatch({ type: SFR_FAMILY_MEMBER_LOADER, isLoadingSFR: true });
        services
            .getSeniorFamilyMember()
            .then((data) => {
                if (data.hasError == false) {
                    if (data["familyMemberList"]) {
                        dispatch({ type: GET_SFR_FAMILY_MEMBER, seniorMemberList: data["familyMemberList"] });
                    }
                }
                dispatch({ type: SFR_FAMILY_MEMBER_LOADER, isLoadingSFR: false });
            })
            .catch(() => {
                dispatch({ type: GET_SFR_FAMILY_MEMBER, seniorMemberList: [] });
                dispatch({ type: SFR_FAMILY_MEMBER_LOADER, isLoadingSFR: false });
            });
    },
    getFamilyAdultMemberDetails: (needToRefresh?: boolean): AppThunkAction<FamilyServiceAction> => (dispatch, getState) => {
        const state = getState();
        if (
            state.familyServiceState &&
            state.familyServiceState.isAdultFamilyMemberDetailsLoaded === false &&
            needToRefresh
        ) {
            services
                .getFamilyAdultMemberDetails()
                .then((data) => {
                        if (data && data.isSuccess) {
                            dispatch({ type: GET_FAMILY_ADULT_MEMBER_DETAILS, isAdultFamilyMember: data["isAdultFamilyMember"] });
                            dispatch({ type: LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS, isAdultFamilyMemberDetailsLoaded: true });
                        }
                    })
                    .catch(() => {
                        dispatch({ type: GET_FAMILY_ADULT_MEMBER_DETAILS, isAdultFamilyMember: false });
                        dispatch({ type: LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS, isAdultFamilyMemberDetailsLoaded: false });
                    });
            }
    }
};

export const getPFSFamilyMember = (dispatch: any) => {
    services
        .getChildSubscribersFPS()
        .then((data) => {
            if (data.isSuccess) {
                if (data["_eZSChildSubscribers"]) {
                    dispatch({ type: GET_FPS_FAMILY_MEMBER, eZSChildSubscribers: data["_eZSChildSubscribers"] });
                }
            }
        })
        .catch(() => {
            dispatch({ type: GET_FPS_FAMILY_MEMBER, eZSChildSubscribers: [] });
        });
};
